module.exports = __webpack_public_path__ + "img/check.001d7131.svg";